import { List, Paper, Typography } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import * as React from "react";

import ListItemContent from "./ListItemContent";
import { TOOLTIP_BORDER_RADIUS } from "./NavigationBar.consts";

const StyledListItem = styled(ListItem, {
  shouldForwardProp: prop => prop !== "open" && prop !== "flush"
})(({ theme, open = true, flush }) => ({
  padding: flush
    ? `${theme.spacing(0.5)} 0`
    : `${theme.spacing(0.5)} ${theme.spacing(open ? 1.5 : 1)}`
}));

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    margin: 0,
    padding: 0,
    backgroundColor: "transparent"
  },
  [`&&[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]: {
    marginLeft: theme.spacing()
  }
}));

const TooltipCard = styled(Paper)(({ theme }) => ({
  borderRadius: TOOLTIP_BORDER_RADIUS,
  padding: theme.spacing(2)
}));

const SideMenuHeader = styled(Typography)(({ theme }) => ({
  color: theme.palette.text[800],
  display: "block"
}));

const SingleListItem = ({ handleClick, navItemIsOpen, open, navItem, ...props }) => {
  const listItemContentProps = navItem => ({
    navItem,
    open,
    navItemIsOpen,
    ...props,
    showIcon: true
  });

  return (
    <StyledListItem open={open} onClick={handleClick(navItem, navItemIsOpen)}>
      {open
        ? <ListItemContent {...listItemContentProps(navItem)} />
        : (
          <StyledTooltip
            placement={navItem.children?.length ? "right-start" : "right"}
            title={(
              <TooltipCard elevation={3}>
                <SideMenuHeader variant="body2">
                  {navItem.text}
                </SideMenuHeader>
                {navItem.children?.length
                  ? (
                    <List sx={{ p: 0 }}>
                      {navItem.children.map(navItem => (
                        <StyledListItem
                          flush
                          key={navItem.key}
                          onClick={handleClick(navItem)}
                        >
                          <ListItemContent
                            {...{
                              ...listItemContentProps(navItem),
                              open: true,
                              showIcon: false
                            }}
                          />
                        </StyledListItem>
                      ))}
                    </List>
                  )
                  : null}
              </TooltipCard>
            )}
          >
            {/* The "div" component is needed here (related to Tooltip component implementation). */}
            <div>
              <ListItemContent {...listItemContentProps(navItem)} />
            </div>
          </StyledTooltip>
        )}
    </StyledListItem>
  );
};

export default SingleListItem;
